import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { PERMISSIONS } from '../constants/permissions.constants'
/**
 * When applied to the home route, redirects users with view_school_site permission
 * directly to the School Site page after login.
 */
export const schoolSiteGuard: CanActivateFn = async () => {
    const _router = inject(Router)
    const permissionService = inject(PermissionService)

    await permissionService.getPermissionsBitwise()
    if (permissionService.getPermissionByName(PERMISSIONS.VIEW_SCHOOL_SITE)) {
        return _router.parseUrl('/school-site')
    }
    return true
}
